import React, { createContext, useState } from 'react';

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  // Initialise l'état pour les données du formulaire salarié
  const [salarieFormData, setSalarieFormData] = useState({
    prenom: '',
    nom_famille: '',
    profil: '', // Assure-toi que cela correspond à l'ID ou au nom du profil
    jours_repos_fixes: [],
    exception_duree_pause: '',
    jours_travail: null,
    heure_fin_service: '',
  });

  const value = {
    salarieFormData,
    setSalarieFormData,
  };

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

